import { EntityType } from '@frontend/common';
import { CommonMessage } from '@frontend/lang';
import { NotificationExtendedClient } from '@frontend/notification/api';
import { notificationRequest } from '@frontend/notification/events';
import { Notification, NotificationExtended } from '@frontend/notification/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ReactiveDetailRegistryEntry } from '../../modal/reactive-detail-shell/reactive-detail.types';
import { NotificationDetailsCard, NotificationMessageSection } from './notification-detail-sections';

export const notificationReactiveDetail: ReactiveDetailRegistryEntry<Notification, NotificationExtended> = {
    entityType: EntityType.NOTIFICATION,
    resolveFunction: notificationRequest,
    fetchExtended: ({ object }) => NotificationExtendedClient.fetchNotificationExtended(object.account_id, object.id),
    modalClassName: 'w-full lg:w-2/3 max-w-[900px]',
    title: () => (
        <FormattedMessage
            id='notification.detail.title'
            defaultMessage='Notification detail'
        />
    ),
    tabs: [
        {
            id: 'general',
            label: CommonMessage.DETAIL.GENERAL,
            render: (view) =>
                view.extended ? (
                    <>
                        <NotificationDetailsCard notification={view.extended} />
                        <NotificationMessageSection notification={view.extended} />
                    </>
                ) : null
        }
    ]
};
